module.exports = __webpack_public_path__ + "media/images/background/background-dna-digital-rotate-71041f92977636038fa9be7c590f68c6.svg";